import React, { FunctionComponent, useState } from "react";
import { TableWrapper } from "./style";
import { Skeleton, Table, TableBody, TableCell, TableContainer, TablePagination, TableRow } from "@mui/material";
import DarkTableHead from "../../molecules/DarkTableHead";
import Prompt from "../../Prompt";

type ListTableProps = {
  columns: string[],
  list: any,
  isLoading?: boolean,
  withPagination?: boolean
}

const ListTable: FunctionComponent<ListTableProps> = ({columns, list, isLoading, withPagination}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const currentList = withPagination ? list.slice(currentPage * 10, currentPage * 10 + 10) : list;

  return (
    <>
      <TableContainer component={TableWrapper} sx={{paddingBottom: "70px"}}>
        <Table>
          <DarkTableHead>
            <TableRow>
              {columns.map((header) => <TableCell key={header}>{header}</TableCell>)}
            </TableRow>
          </DarkTableHead>
          <TableBody>
            {isLoading ? [...Array(10)].map((_, index) => (
              <TableRow key={index}>
                {[...Array(columns.length)].map((_, index) => (
                  <TableCell key={index}>
                    <Skeleton variant="rectangular" height={14} />
                  </TableCell>
                ))}
              </TableRow>
            )) :
              currentList.map((row, index) => {
                return (
                  <TableRow key={index}>
                    {row.map((cell, index) => <TableCell key={index}>{cell}</TableCell>)}
                  </TableRow>    
                );
              })
            }
          </TableBody>
        </Table>
      </TableContainer>
      {withPagination && <Prompt>
        <TablePagination
          component="div"
          count={list.length}
          page={currentPage}
          onPageChange={(e, page) => setCurrentPage(page)}
          rowsPerPage={10}
          rowsPerPageOptions={[]}
        />
      </Prompt>}
    </>
  );
};

export default ListTable;